import {
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import React, { Fragment, useEffect, useRef, useState } from "react";
import PartForm from "../../../components/partForm/PartForm";
import { useFetch } from "../../../features/customHooks/useFetch";
import Part from "../part/Part";

const Parts = (props) => {
  const { data } = props;
  const { valuationId = 0, parts = [], loading = true, reget, canEdit } = data;

  const partRef = useRef(null);

  const [dialogOpen, setDialogOpen] = useState({ open: false, data: null, mode: "new" });
  const handleOpenDialog = (open, data = null, mode = "new") => setDialogOpen({ open, data, mode });
  const handleCloseDialog = () => setDialogOpen({ open: false, data: null, mode: "new" });

  const [deleteDialog, setDeleteDialog] = useState({ open: false, data: null });
  const handleOpenDeleteDialog = (open, data) => setDeleteDialog({ open: true, data: data });
  const handleCloseDeleteDialog = () => setDeleteDialog({ open: false, data: null });

  const [fetchState, setFetchParams] = useFetch();
  const [deleteFetchState, setDeleteFetchParams] = useFetch();

  const onSubmitForm = (data, event) => {
    var params = {};
    if (dialogOpen.mode === "new") {
      params = {
        method: "post",
        url: "/part",
        data: {
          valuation_id: valuationId,
          ...data,
        },
      };
    } else {
      params = {
        method: "put",
        url: "/part/" + dialogOpen?.data?.id,
        data: {
          valuation_id: valuationId,
          ...data,
        },
      };
    }
    setFetchParams(params);
  };

  const handleDeleteCredit = () => {
    const params = {
      method: "delete",
      url: "/part/" + deleteDialog?.data?.id,
    };
    setDeleteFetchParams(params);
  };

  useEffect(() => {
    if (!deleteFetchState.loading && !deleteFetchState.error && deleteFetchState.data) {
      handleCloseDeleteDialog();
      reget();
    }

    if (!deleteFetchState.loading && deleteFetchState.error) {
      console.log("error");
    }
  }, [deleteFetchState]); // eslint-disable-line

  useEffect(() => {
    if (!fetchState.loading && !fetchState.error && fetchState.data) {
      handleCloseDialog();
      reget();
    }

    if (!fetchState.loading && fetchState.error) {
      console.log("error");
    }
  }, [fetchState]); // eslint-disable-line

  return (
    <Paper style={{ padding: 10 }}>
      <Grid container alignItems='center'>
        <Typography variant='h6' style={{ fontWeight: "bold" }}>
          بخش های ملک
        </Typography>

        <div style={{ flexGrow: 1 }} />

        {canEdit && (
          <Tooltip title='افزودن'>
            <IconButton onClick={() => handleOpenDialog(true, null, "new")}>
              <Add />
            </IconButton>
          </Tooltip>
        )}
      </Grid>

      <Grid container direction='row'>
        {loading ? (
          <Grid container alignItems='center' justifyContent='center'>
            <CircularProgress style={{ color: "#757575" }} />
          </Grid>
        ) : parts?.length > 0 ? (
          <Fragment>
            {parts.map((part) => (
              <Part
                data={part}
                type='part'
                key={part?.id}
                canEdit={canEdit}
                handleOpenDialog={handleOpenDialog}
                handleOpenDeleteDialog={handleOpenDeleteDialog}
              />
            ))}
          </Fragment>
        ) : (
          <Chip label='بخشی برای نمایش وجود ندارد!' />
        )}
      </Grid>
      {canEdit && (
        <Fragment>
          <Dialog open={deleteDialog.open} maxWidth={"xs"} fullWidth>
            <DialogTitle>{"حذف بخش"}</DialogTitle>
            <DialogContent>
              <Typography>آیا مایل به حذف این بخش هستید؟</Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDeleteDialog}>لغو</Button>
              <Button variant='contained' color='primary' onClick={handleDeleteCredit}>
                {deleteFetchState?.loading ? <CircularProgress size={23} color='inherit' /> : "حذف"}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={dialogOpen.open} maxWidth={"xs"} fullWidth>
            <DialogTitle>{dialogOpen.mode === "new" ? "افزودن بخش" : "ویرایش بخش"}</DialogTitle>
            <DialogContent>
              <PartForm ref={partRef} defaultValues={dialogOpen.data} onSubmitForm={onSubmitForm} />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog}>لغو</Button>
              <Button variant='contained' color='primary' onClick={() => partRef.current.submit()}>
                {fetchState?.loading ? (
                  <CircularProgress size={23} color='inherit' />
                ) : dialogOpen.mode === "new" ? (
                  "افزودن"
                ) : (
                  "ویرایش"
                )}
              </Button>
            </DialogActions>
          </Dialog>
        </Fragment>
      )}
    </Paper>
  );
};

export default Parts;
